import { useEffect } from "react";
import socket from "../utils/socket-io";

/*eslint-disable no-console*/

const useSocket = () => {
  useEffect(() => {
    // Connection established
    socket.on("connect", () => {
      console.log("Socket connected on page load");
    });

    // Handle errors
    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    // Disconnected
    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    // Cleanup on component unmount
    return () => {
      socket.off("connect");
      socket.off("connect_error");
      socket.off("disconnect");
    };
  }, []);
};

export default useSocket;
